import React, { FC, useEffect } from 'react'

import { layout } from '../../style/variables'
import { media } from '../../style/media'
import { SocialMediaPostBlockFields } from './types'

export enum SocialPostType {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  LINKEDIN = 'LINKEDIN', // Has no script requirements at present
  TWITTER = 'TWITTER',
  YOUTUBE = 'YOUTUBE', // Has no script requirements at present
}

const getSupportingScripts = (type: SocialPostType): string[] => {
  switch (type) {
    case SocialPostType.FACEBOOK:
      return ['https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v7.0']
    case SocialPostType.INSTAGRAM:
      return ['https://www.instagram.com/embed.js']
    case SocialPostType.TWITTER:
      return ['https://platform.twitter.com/widgets.js']
    default:
      return []
  }
}

interface SocialMediaPostBlockProps {
  fields: SocialMediaPostBlockFields
}

export const SocialMediaPostBlock: FC<SocialMediaPostBlockProps> = ({ fields }) => {
  useEffect(() => {
    const scriptUrls = getSupportingScripts(fields.type)
    const scriptHandles = scriptUrls.map((url) => {
      const script = document.createElement('script')
      script.src = url
      script.async = true
      script.defer = true
      document.body.appendChild(script)
      return script
    })
    return (): void => {
      scriptHandles.forEach((script) => {
        document.body.removeChild(script)
      })
    }
  }, [fields.type])

  const isYoutube = fields.type.toUpperCase() === SocialPostType.YOUTUBE

  return (
    <>
      <style jsx>{`
        .iframe-wrapper {
          position: relative;
          padding-top: 56.25%;
          overflow: hidden;
        }
        iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 0;
        }
        .embed-content {
          margin: auto;
          max-width: ${layout.heroWidth.tablet}px;
          padding: 15px;
        }
        @media ${media.tabletAndHigher} {
          .embed-content {
            max-width: ${layout.heroWidth.tablet}px;
            padding: 0;
          }
        }
        @media ${media.desktopAndHigher} {
          .embed-content {
            max-width: ${layout.heroWidth.desktop}px;
          }
        }
      `}</style>
      {isYoutube ? (
        <div className="embed-content">
          <div className="iframe-wrapper">
            <iframe
              title="YouTube"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              src={fields.html.substring(fields.html.lastIndexOf('src="') + 5, fields.html.lastIndexOf('" ', 82))}
            />
          </div>
        </div>
      ) : (
        <div className="embed-content" dangerouslySetInnerHTML={{ __html: fields.html }}></div>
      )}
    </>
  )
}
